<template lang="html">
  <v-page class="page-landing">
    <div
      class="block-cover"
      style="background-image:url(static/landing/cover.jpg);"
    >
      <v-container>
        <v-logo class="mb-4" white />
        <v-row size="2">
          <v-col :xs="12" :lg="6">
            <div>
              <v-text tag="h2" class="mb-3">
                Bem vindo a plataforma Vibbra
              </v-text>
              <v-text tag="h5">
                Encontre os melhores profissionais remotos de TI do Brasil e
                contrate de forma segura e confiável!
              </v-text>
              <small
                >Quer saber mais sobre a Vibbra?
                <a
                  href="http://vibbra.com.br/"
                  target="_blank"
                  title="Site Vibbra"
                  >Acesse nosso site</a
                ></small
              >
            </div>
          </v-col>
          <v-col :xs="12" :md="6" :lg="3">
            <v-card class="p-3 m-0">
              <v-text tag="h5" class="mb-3">
                Contratante
              </v-text>
              <v-text tag="p" class="mb-3">
                Conheça nossos profissionais!
              </v-text>
              <v-button @click="to('client')" class="gray block"
                >Acesse sua conta</v-button
              >
            </v-card>
          </v-col>
          <v-col :xs="12" :md="6" :lg="3">
            <v-card class="p-3 m-0">
              <v-text tag="h5" class="mb-3">
                Profissional
              </v-text>
              <v-text tag="p" class="mb-3">
                Receba oportunidades!
              </v-text>
              <v-button @click="toSelectionLogin()" class="gray block"
                >Acesse sua conta</v-button
              >
              <v-divider line>ou</v-divider>
              <v-button @click="toSelection()" class="primary block"
                >Candidate-se</v-button
              >
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="block-functionalities">
      <div v-for="item in functionalities" class="list-item">
        <v-container>
          <v-row>
            <v-col :xs="12" :lg="5">
              <v-text tag="h4" class="mb-4">
                {{ item.title }}
              </v-text>

              <v-text tag="h6" class="mb-4">
                {{ item.subtitle }}
              </v-text>
            </v-col>
            <v-col :xs="12" :lg="7">
              <v-image :src="item.image" />
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <div
      class="block-cover"
      style="background-image:url(static/landing/cover-2.jpg);"
    >
      <v-container>
        <v-row size="2" class="justify-content-center">
          <v-col :xs="12" :md="6" :lg="3">
            <v-card class="p-3 m-0">
              <v-text tag="h5" class="mb-3">
                Contratante
              </v-text>
              <v-text tag="p" class="mb-3">
                Conheça nossos profissionais!
              </v-text>
              <v-button @click="to('client')" class="gray block"
                >Acesse sua conta</v-button
              >
            </v-card>
          </v-col>
          <v-col :xs="12" :md="6" :lg="3">
            <v-card class="p-3 m-0">
              <v-text tag="h5" class="mb-3">
                Profissional
              </v-text>
              <v-text tag="p" class="mb-3">
                Receba oportunidades!
              </v-text>
              <v-button @click="toSelectionLogin()" class="gray block"
                >Acesse sua conta</v-button
              >
              <v-divider line>ou</v-divider>
              <v-button @click="toSelection()" class="primary block"
                >Candidate-se</v-button
              >
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-page>
</template>

<script>
export default {
  methods: {
    to(profile) {
      // this.$app.profile.id = profile
      this.$router.push({
        name: profile + '-login',
      });
    },
    toRegister() {
      this.$router.push({
        name: 'client-register',
      });
    },
    toSelection() {
      const win = window.open(
        'https://selecao.vibbra.com.br/sign-up',
        '_blank'
      );
      win.focus();
    },
    toSelectionLogin() {
      const win = window.open('https://selecao.vibbra.com.br/', '_blank');
      win.focus();
    },
  },
  data() {
    return {
      functionalities: [
        {
          title: 'Explore a nossa rede de profissionais de alto nível',
          subtitle:
            'Busque aqueles profissionais que são ideais para atuarem nos seus projetos. Pesquise por perfil, foco de atuação, habilidades, valor/hora, anos de experiência e horas disponíveis por semana.',
          image: 'static/landing/prints/busca-vibbrantes.png',
        },
        {
          title: 'Analise os perfis detalhados de cada profissional',
          subtitle:
            'Acesse o perfil detalhado de cada profissional. Veja informações importantes como a nota do profissional na seleção da Vibbra, nota de qualidade de código (para desenvolvedores), portfólio (para designers), principais habilidades, dentre outras.',
          image: 'static/landing/prints/perfil-vibbrante.png',
        },
        {
          title: 'Selecione e requisite os profissionais que deseja contratar',
          subtitle:
            'Para cada profissional selecionado, informe por quantas horas deseja contratá-lo e uma breve descrição para que saiba do que se trata o trabalho. Caso não saiba quantas horas informar, pode indicar 1h e realizar adendos depois, ou solicitar ajuda da nossa equipe.',
          image: 'static/landing/prints/selecao-vibbrantes.png',
        },
        {
          title:
            'Assine o seu contrato com a Vibbra e nós assinamos com os profissionais',
          subtitle:
            'Os profissionais requisitados são notificados da sua demanda. Aqueles que estão disponíveis assinam um contrato com a Vibbra. Após isso, assinamos igualmente um contrato com você, intermediando essa questão sem gerar vínculos trabalhistas.',
          image: 'static/landing/prints/vibbrante-disponivel.png',
        },
        {
          title:
            'Realize a compra de créditos para liberar horas dos profissionais',
          subtitle:
            'Trabalhamos com o conceito de créditos, ou seja, para que o profissional possa começar a executar as horas contratadas, você precisa ter créditos na sua carteira que serão consumidos em horas trabalhadas dos seus profissionais.',
          image: 'static/landing/prints/compra-creditos.png',
        },
        {
          title: 'Acompanhe o consumo das horas contratadas',
          subtitle:
            'Para cada profissional contratado você tem acesso a um painel de acompanhamento de horas. Nele você acompanha cada atividade x horas reportadas pelo profissional, podendo solicitar revisão caso tenha alguma dúvida.',
          image: 'static/landing/prints/acompanhamento-horas.png',
        },
        {
          title: 'Avalie os contratos finalizados',
          subtitle:
            'Após finalizar as horas contratadas, você pode avaliar como foi o trabalho com cada profissional. Avalie a qualidade do resultado, o profissionalismo do profissional e nos diga se você voltaria a trabalhar com ele no futuro.',
          image: 'static/landing/prints/vibbrante-finalizado.png',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.page.page-landing {
  padding-top: 0;
  .block-cover {
    padding: 10em 0;
    position: relative;
    background-size: cover;
    color: #fff;
    background-position: center;

    .card {
      color: gray(900);
    }
    &:before {
      content: '';
      background-color: rgba(0, 0, 0, 0.45);
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
    a {
      color: #fff;
      text-decoration: underline;
    }
  }
  .block-functionalities {
    .list-item {
      padding: 10em 0;
      &:nth-of-type(odd) {
        background-color: #fff;

        .row {
          flex-direction: row-reverse;
        }
      }
      .image {
        box-shadow: 0 10px 50px -12px rgba(171, 171, 171, 0.9);
      }
    }
  }
  .page-footer {
    margin: 0;
    background: #202128;
    border: 0;
    color: #eee;
  }

  @include media-breakpoint-down(md) {
    .block-cover,
    .block-functionalities .list-item {
      padding: 5em 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/index.vue